import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LiveAnnouncerService {
  private announcement$ = new Subject<string>();
  private timeoutId: ReturnType<typeof setTimeout> | null = null;
  private timeoutGeneration = 0;

  announce(announcement: string) {
    this.clearPendingTimeouts();

    this.announcement$.next(announcement);
    const generation = ++this.timeoutGeneration;
    this.timeoutId = setTimeout(() => {
      if (this.timeoutGeneration !== generation) {
        return;
      }

      this.announcement$.next('');
      this.timeoutId = null;
    }, 1000);
  }

  getAnnouncement() {
    return this.announcement$.asObservable();
  }

  clearPendingTimeouts() {
    this.timeoutGeneration++;

    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
